import { render, staticRenderFns } from "./NewsUpdateModalWrapper.vue?vue&type=template&id=cd298e3c"
import script from "./NewsUpdateModalWrapper.vue?vue&type=script&lang=js"
export * from "./NewsUpdateModalWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports